import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../app.constants';
import { OidcSecurityService } from '../auth/services/oidc.security.service';
import { SimApnModel } from '../shared/models/sim-related/SimApnModel';
import { SimTypeModel } from '../shared/models/sim-related/SimTypeModel';
import { UnitFirmwareModel } from '../shared/models/unit-related/UnitFirmwareModel';
import { UnitPlanModel } from '../shared/models/unit-related/UnitPlanModel';
import { ContactActionModel } from '../shared/models/contact-related/ContactActionModel';
import { CompanyListModel } from '../shared/models/company-related/CompanyListModel';
import { ContactListModel } from '../shared/models/contact-related/ContactListModel';
import { CompanyTypeModel } from '../shared/models/company-related/CompanyTypeModel';
import { ProductListModel } from '../shared/models/product-related/ProductListModel';
import { CourierListModel } from '../shared/models/courier-related/CourierListModel';
import { AddressModel } from '../shared/models/address-related/AddressModel';
import { ProductTypeModel } from '../shared/models/product-related/ProductTypeModel';

declare var Materialize: any;
declare var $: any;

@Injectable()
export class PopulateFormService {

    private actionUrl: string;
    private headers: Headers;

    constructor(private _http: Http, private _configuration: Configuration, private _securityService: OidcSecurityService) {
    }

    private setHeaders() {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');

        let token = this._securityService.getToken();
        if (token !== '') {
            let tokenValue = 'Bearer ' + token;
            this.headers.append('Authorization', tokenValue);
        }
    }

    // Used to update form after select model arrays are updated
    // and move label for prepopulated inputs
    public updateFormView(): void {
        this.updateSelectListView();
        this.updateInputView();
    }

    // This is used to update the select list once the model array have been updated
    // There seems to be an issue with Materialize not automatically updaing and a
    // callback doesnt work so a timeout is used as a last resort.
    public updateSelectListView(): void {
        setTimeout(() => { $('select').material_select(); }, 1);
    }

    // Update inputs -- used when inputs are pre-populated
    // This is a hack due to Materialize CSS Framework not
    // detecting pre-population and moving label
    public updateInputView(): void {
        setTimeout(() => { Materialize.updateTextFields() }, 1);
    }

    public updateTabs(): void {
        setTimeout(() => { $('ul.tabs').tabs(); }, 10);
    }

    public GetCompanySelectList = (companyType: string, chargeDirectOnly: boolean): Observable<CompanyListModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/CompanyList/`;

        this.setHeaders();
        let params: URLSearchParams = new URLSearchParams();
        params.set('companyType', companyType);
        params.set('chargeDirectOnly', String(chargeDirectOnly));
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetCompanyTypeSelectList = (): Observable<CompanyTypeModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/CompanyTypeList/`;

        this.setHeaders();
        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetProductSelectList = (): Observable<ProductListModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/ProductList/`;

        this.setHeaders();
        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetProductTypeSelectList = (): Observable<ProductTypeModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/ProductType/`;

        this.setHeaders();
        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetCourierSelectList = (): Observable<CourierListModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/CourierList/`;

        this.setHeaders();
        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetSimApnSelectList = (): Observable<SimApnModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/SimApn/`;

        this.setHeaders();
        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetSimTypeSelectList = (): Observable<SimTypeModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/SimType/`;

        this.setHeaders();
        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetUnitFirmwareSelectList = (): Observable<UnitFirmwareModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/UnitFirmware/`;

        this.setHeaders();
        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetUnitPlanSelectList = (): Observable<UnitPlanModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/UnitPlan/`;

        this.setHeaders();
        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetContactSelectList = (): Observable<ContactListModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/ContactList/`;

        this.setHeaders();
        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetContactActionSelectList = (): Observable<ContactActionModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/ContactAction/`;

        this.setHeaders();
        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public GetEntityAddressSelectList = (entityId: string): Observable<AddressModel[]> => {
        this.actionUrl = `${this._configuration.Server}api/EntityAddress/`;
        this.setHeaders();
        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl + entityId, options).map(res => res.json());
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/services/populate-form.ts